// Public page options belong to the annual event; legacy/holiday pages keep
// their own rendering. This model contains no admin tokens or private fields.
export function annualEventPageModel(event = {}) {
    const page = event.annualEventPage || {};
    const links = (event.links || []).filter(link => /^https?:\/\//i.test(link.url || '') || /^\/(?!\/)/.test(link.url || '') || /^#[a-zA-Z0-9_-]+$/.test(link.url || ''));
    const tools = links.filter(link => link.kind === 'registration' || link.kind === 'fundraising');
    const primary = tools[0] || null;
    return {
        layout: ['essential', 'story', 'campaign'].includes(page.layout) ? page.layout : 'essential',
        tone: ['auto', 'blue', 'cyan', 'violet', 'green', 'amber', 'rose', 'red'].includes(event.annualEventVisual?.tone) ? event.annualEventVisual.tone : 'auto',
        description: page.showDescription === false ? '' : event.description || event.content || '',
        practical: page.showPracticalInfo !== false,
        organizer: page.showOrganizer === true,
        progress: page.showProgress === true ? (event.fundraisers || []) : [],
        primary: primary ? {...primary, name: page.ctaLabel || primary.name} : null,
        links,
    };
}
